<template>
  <div class="top">
    <div id="nav">
      <div id="left" @click="back"><van-icon name="arrow-left" /> 返回</div>
      <div id="title">
        解忧密语
      </div>
    </div>
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { Toast } from "vant";
// import "./font/iconfont.css";
// import wx from "wx-js-sdk";

export default {
  data() {
    return {};
  },
  methods: {
    back() {
      this.$router.push({
        path: "/",
        query: { channel: this.$route.query.channel },
      });
    },
  },
  created() {
    // console.log(window.location.href);
    // alert(window.location.href);
  },
};
</script>
<style lang="scss" scoped>
#nav {
  background-color: #fff;
  font-size: 0.16rem;
  line-height: 0.4rem;

  height: 0.4rem;
  display: flex;
  width: 100%;
  position: relative;
  align-items: center;
}
#left {
  position: absolute;
  height: 0.4rem;
  line-height: 0.4rem;
  vertical-align: bottom;
  i {
    top: 8%;
  }

  left: 0.2rem;
}
#title {
  // text-align: center;
  margin: 0 auto;
}
</style>
